const o = `<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.5,3.5a2.473,2.473,0,0,0-.78.125A3.5,3.5,0,1,0,3.5,8.5h4a2.5,2.5,0,0,0,0-5Z" fill="currentColor"
        stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path>
</svg>`;
export {
  o as default
};
